/* global showSuccessToast */
/* global showInfoToast */

import React, { useState, useEffect, useCallback } from "react";
import { getContactHistory, addContactHistory } from "../../api/api";

const OUTCOME_COLORS = ["#222", "#dc3545", "#fd7e14", "#28a745", "#007bff"];
const OUTCOME_BUTTONS = [
    { value: "0", label: "1 Mese", className: "bg-dark" },
    { value: "1", label: "2 Settimane", className: "bg-danger" },
    { value: "2", label: "1 Settimana", className: "bg-warning" },
    { value: "3", label: "3 giorni", className: "bg-success" },
    { value: "4", label: "Fine mese", className: "bg-primary" }
];

const ContactHistoryModal = ({ selectedContact, users }) => {
    const [formDate, setFormDate] = useState(() => new Date().toISOString().slice(0, 10));
    const [formNotes, setFormNotes] = useState("");
    const [formRatio, setFormRatio] = useState("");
    const [contactHistory, setContactHistory] = useState([]);

    const loadContactHistory = useCallback(async (contact) => {
        const response = await getContactHistory(contact.id);
        setContactHistory(response.data?.data?.getContactHistoryListing?.edges || []);
    }, []);

    useEffect(() => {
        if (selectedContact) {
            setContactHistory([]);
            loadContactHistory(selectedContact);
        }
    }, [selectedContact, loadContactHistory]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const plainData = Object.fromEntries(new FormData(e.target).entries());
        await addContactHistory(plainData);
        showSuccessToast("Ricontatto aggiunto con successo!");
        setFormNotes("");
        setFormRatio("");
        loadContactHistory(selectedContact);
    };

    const phone = selectedContact?.phone || "";

    return (
        <div>
            <form className="row" method="post" onSubmit={handleSubmit}>
                <input type="hidden" name="Contact" value={selectedContact ? selectedContact.id : ""} />
                <div className="form-group col-sm-4 col-12">
                    <label htmlFor="event-date">Data ricontatto</label>
                    <input
                        type="date"
                        className="form-control"
                        id="event-date"
                        name="date"
                        value={formDate}
                        onChange={e => setFormDate(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group col-sm-4 col-12">
                    <label htmlFor="event-date">Utente</label>
                    <select className="form-control" name="User" required defaultValue="">
                        <option value=""></option>
                        {users.map((user, index) => (
                            <option key={index} value={user.node.id}>{user.node.username}</option>
                        ))}
                    </select>
                </div>
                <div className="form-group col-sm-4 col-12">
                    <label htmlFor="event-ratio">Conversion time</label>
                    <select
                        className="form-control"
                        id="event-ratio"
                        name="outcome"
                        value={formRatio}
                        onChange={e => setFormRatio(e.target.value)}
                        required
                    >
                        <option value=""></option>
                        <option value="4">Fine mese</option>
                        <option value="3">3 giorni</option>
                        <option value="2">1 Settimana</option>
                        <option value="1">2 Settimane</option>
                        <option value="0">1 Mese</option>
                    </select>
                </div>
                {/* <div className="form-group col-12">
                    <div className="row text-center justify-content-center">
                        {OUTCOME_BUTTONS.map(button => (
                            <a key={button.value} href="#" onClick={e => { e.preventDefault(); setFormRatio(button.value); }} className={`col-2 p-0 ${button.className}`}>
                                <span className="text-white font-weight-bold">{button.label}</span>
                            </a>
                        ))}
                    </div>
                </div> */}
                <div className="form-group col-12">
                    <div className="d-flex text-center">
                        {OUTCOME_BUTTONS.map(button => (
                            <a
                                key={button.value}
                                href="#"
                                onClick={e => { e.preventDefault(); setFormRatio(button.value); }}
                                className={`d-flex align-items-center justify-content-center p-1 ${button.className}`}
                                style={{ flex: "1 1 0", minWidth: 0 }}
                            >
                                <span className="text-white font-weight-bold" style={{ fontSize: "clamp(8px, 1.1vw, 12px)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{button.label}</span>
                            </a>
                        ))}
                    </div>
                </div>
                <div className="form-group col-12">
                    <label htmlFor="event-notes">Note/Messaggio</label>
                    <textarea
                        className="form-control"
                        id="event-notes"
                        name="note"
                        rows={5}
                        value={formNotes}
                        onChange={e => setFormNotes(e.target.value)}
                        placeholder="Aggiungi una nota dettagliata o il testo del messaggio da inviare..."
                        required
                    />
                </div>
                <div className="form-group col-6">
                    <a href={selectedContact ? "tel:+39" + phone : ""} onClick={() => showInfoToast("Procedi su Collegamento telefono!")}>
                        <button type="button" className="btn btn-secondary btn-block col">Chiama</button>
                    </a>
                </div>
                <div className="form-group col-6">
                    <a href={selectedContact ? "whatsapp://send?phone=39" + phone + "&text=" + encodeURIComponent(formNotes) : ""} target="_blank" rel="noreferrer" onClick={() => showInfoToast("Procedi su WhatsApp!")}>
                        <button type="button" className="btn btn-secondary btn-block col">Invia messaggio</button>
                    </a>
                </div>
                <div className="form-group col-12">
                    <button type="submit" className="btn btn-primary btn-block col">Conferma ricontatto</button>
                </div>
            </form>
            <div className="d-flex flex-column gap-2" style={{ maxHeight: "300px", overflowY: "auto", paddingTop: "10px" }}>
                {selectedContact && contactHistory.length > 0 ? (
                    contactHistory.map((edge, idx) => {
                        const event = edge.node;
                        return (
                            <div key={idx} className="card mb-2 shadow-sm" style={{ borderLeft: `5px solid ${OUTCOME_COLORS[event.outcome] || "#ccc"}` }}>
                                <div className="card-body p-2">
                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                        <div>
                                            <strong className="mr-2">{event.date ? new Date(event.date).toLocaleDateString("it-IT") : ""}</strong>
                                            <br />
                                            <i>{event.note}</i>
                                        </div>
                                        <span className="text-muted" style={{ fontSize: 13 }}>
                                            {event.User ? event.User[0].username : "Utente sconosciuto"}
                                        </span>
                                    </div>
                                    <div>
                                        <span className="d-block">{event.description}</span>
                                    </div>
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <div className="text-center text-muted py-4">Nessun ricontatto effettuato.</div>
                )}
            </div>
        </div>
    );
};

export default ContactHistoryModal;
